// pdp accrodion

$(document).ready(function() {
  $(".ctm-accordion-title").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".ctm-accordion-content")
        .slideUp(200);
      $(this).find(".toggler-arrow").removeClass("hide-arrow");
      $(this).siblings(".ctm-accordion-content").find(".toggler-arrow").removeClass("hide-arrow");
      // $(".set > a i")
      //   .removeClass("fa-minus")
      //   .addClass("fa-plus");
    } else {
      // $(".set > a i")
      //   .removeClass("fa-minus")
      //   .addClass("fa-plus");
      // $(this)
      //   .find("i")
      //   .removeClass("fa-plus")
      //   .addClass("fa-minus");
      $(this).find(".toggler-arrow").addClass("hide-arrow");
      $(".ctm-accordion-title").removeClass("active");
      $(this).addClass("active");
      $(".ctm-accordion-content").slideUp(200);
      $(this)
        .siblings(".ctm-accordion-content")
        .slideDown(200);
      $(this).parent().siblings().find('.toggler-arrow').removeClass("hide-arrow");
    }
  });
});


$(document).ready(function() {
  $('.default-accordion').addClass('active');
  $('.default-accordion-content').css('display', 'block');
});

// announcement bar slider

function Hide(HideID){
 HideID.style.display = "none";
 $('body').addClass('announcement-cart');
}


$('document').ready(function(){


  if ($('.announcement-bar').length) {
    $('.announcement-bar').each(function() {
      new Swiper(this, {
          fadeEffect: { crossFade: true },
          virtualTranslate: true,
          autoplay: {
              delay: 5000,
          },
          speed: 1000,
          slidersPerView: 1,
          effect: "fade",
          navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
          },
          loop: false,
      });
  });
  }
// Testimonials
    if ($('.testimonial-slider').length) {

        new Swiper('.testimonial-slider', {
          fadeEffect: { crossFade: true },
          virtualTranslate: true,
          autoplay: {
              // delay: 500,
              disableOnInteraction: false,
          },
          // speed: 500, 
          slidersPerView: 1,
          effect: "fade",
            loop: true,
            slidesPerView: 1,
            paginationClickable: true,
            spaceBetween: 20,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: '.swiper-pagination',
            },
            
        });
      }

      if ($('.new-testimonial-slider').length) {

        new Swiper('.new-testimonial-slider', {
            loop: true,
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 9,
            navigation: {
              nextEl: ".testimonials-swiper-button-next",
              prevEl: ".testimonials-swiper-button-prev",
            },
            pagination: {
              el: '.swiper-pagination',
            },
            
        });
      }

      if ($('.services-slider').length) {

        new Swiper('.services-slider', {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: true,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            breakpoints: {
              0: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
              700: {
                slidesPerView: 2,
                spaceBetween: 0,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 0,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 0,
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 50,
                loop:false,
              },
            },
        });
      }

      // setTimeout(function(){
      //   if ($(".spr-reviews").length) {
      //     var slickCarousel = $(".spr-reviews");
      //     slickCarousel.slick({
      //       infinite: true,
      //       speed: 300,
      //       slidesToShow: 4,
      //       slidesToScroll: 1,
      //       vertical: true,
      //       verticalSwiping: true,
      //       dots: false,
      //       arrows: false,
      //     });
      //   }
      // },10000);
      
      
$(".main-video").on('click',function() {
  if ($("#video_banner").get(0).paused) {
      $("#video_banner").trigger('play');
      $(".video-playbtn").fadeOut(300);
  } else {
      $("#video_banner").trigger('pause');
      $(".video-playbtn").fadeIn(300);
  }
});



// popup for founder details
$('.trigger_img').each(function(i){
  $(this).on('click',function() {
    $('body, html').addClass('founder_pop_active');
    var get_id = $(this).attr('id');
    var arr = get_id.split('_');
    $("#show_model_"+arr[1]).fadeIn(300);
  }); 
});
$('.meet-founder-ctm .popup .close').each(function(i){
  $(this).on('click',function() {
    $('body, html').removeClass('founder_pop_active');
    var get_id_close = $(this).closest('.popup').attr('id');
    var arr_close = get_id_close.split('_');
    $("#show_model_"+arr_close[2]).fadeOut(300);
  }); 
});



});


//common slider script
var swiper = new Swiper('.common-slider', {
  slidesPerView: 3.5,
  centeredSlides: true,
  loop: true,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    0: {
      slidesPerView: 3.2,
      spaceBetween: 3,
    },
    640: {
      slidesPerView: 3.2,
      spaceBetween: 8,
    },
    1200: {
      slidesPerView: 3.5,
      spaceBetween: 20,
    },
  },
});

// mobile sub-menu hide show
$('.menu-drawer__menu .ctm_click').on('click', function(){
  
  if( $(this).children('.drop-box-ctm').hasClass('submenu-open-ctm') ){
    $(this).children('.drop-box-ctm').removeClass('submenu-open-ctm');
    setTimeout(function(){ 
      $(this).children('.drop-box-ctm').removeAttr('open');
    }, 1000);
  } else {
      $('.menu-drawer__menu .ctm_click .drop-box-ctm').removeClass('submenu-open-ctm');
      $('.menu-drawer__menu .ctm_click .drop-box-ctm').removeAttr('open');
      $(this).children('.drop-box-ctm').addClass('submenu-open-ctm');
      $(this).children('.drop-box-ctm').attr('open');
  }
});

$('.header__icon--summary').on('click',function(){
  if($('.cart_dropdown_ctm').hasClass('drawer_active')){
    $('.header__icon--cart').trigger('click');
  }
  $('body').toggleClass('menu_open_body');
  $('html').toggleClass('menu_open_body');
  if($('body').hasClass('menu_open_body'))
  {
    $('body').addClass('modal-overlay-active');
  }else{
    $('body').removeClass('modal-overlay-active');
  }
});




// Ajax cart drawer 

$('.cart_close').on('click', function(){
  $('.cart-dropdown').removeClass('drawer_active');
  // $('.cart-dropdown').addClass('hidden');
  $('#cart-icon-bubble').removeClass("ctm-cart-color");
});



function addItem(form_id) {
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: $('#' + form_id).serialize(),
      success: addToCartOk,
      error: addToCartFail
  });
}

function addToCartOk() {
  fetchCart();
  $(".cart-dropdown").addClass("drawer_active");
  $('#cart-icon-bubble').addClass("ctm-cart-color");
  $('body').addClass('modal-overlay-active');
  $('body').addClass('modal-close');
  $('.modal-overlay').css('background', 'transparent');
  openModal();
  
  
}

function addToCartFail(obj, status) {
  $('.modal').html('The product you are trying to add is out of stock.');
  openModal()
}

function fetchCart() {
  $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
  
          if (cart.item_count === 0) {
              $('.js-empty-cart__message').removeClass('hidden');
              $('.upsell-cart-drawer').addClass('hidden');
              $('.bottom-cart').addClass('hidden');
              $('.cart-title').addClass('hidden');
              $('.scrollable').addClass('hidden');
             
          } else {
              renderCart(cart);
              cartCount();
              
              
          }
      },
  });
}

function cartCount(){
 
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (cart) {
      onCartUpdate(cart);
    }
  });
}


function onCartUpdate(cart) {
  var cart_count = cart.item_count;
  
  if(cart_count != 0){
    $('.cart-count-bubble').css('display','block');
    $('.cart-count-bubble span').html(cart_count);
  }else{
    $('.cart-count-bubble').css('display','none');
  }
  

}

function openModal(cart) {
  setTimeout(function() {
      // $('.cart-dropdown').removeClass('hidden');
      $('.cart-dropdown').addClass('drawer_active testtt');
      $('#cart-icon-bubble').addClass("ctm-cart-color");
      $('.js-empty-cart__message').addClass('hidden');
      $('.bottom-cart').removeClass('hidden');
      $('.cart-title').removeClass('hidden');
      $('.scrollable').removeClass('hidden');
      $('html').addClass('active-cart');
  }, 500);
}

function renderCart(cart) {
  clearCartDrawer();
  addCompareAtPrice(cart);
  $('.cart-count-bubble > span').text(cart.items.length);
  if (cart.items.length > 0) {
      document.getElementById('drawer_checkout_btn').removeAttribute('disabled', 'disabled');
      
      cart.items.forEach(function(product, index) {
        
          index = index + 1;
          var price = (product['final_price'] / 100);
          var comapre_price = (product['compare_at_price'] / 100);
          var pro_url = product.url;
     
          
          var concatProductInfo = '<div class="product product-cart row">';
              
              concatProductInfo += '<div class="left-content"><a href=" ' + pro_url + ' " class="product-name"><img src="' + product.featured_image.url + '" alt="' + product.featured_image.alt + '" width="100%" ></a></div>';
              
              concatProductInfo +='<div class="middle-content"><div class="product-name"><a href=" ' + pro_url + ' " class="product-name">' + product.title + '</a></div><div class="product-btm"><div class="product-price">$' + price.toFixed(2) + '</div><s class="compare-price">$' + comapre_price.toFixed(2) + '</s>';

              /** Quantity **/
              concatProductInfo +='<div class="cart-item__quantity-wrapper"><div class="quantity"><button type="button" class="quantity-change button_primary btn-minus" data-ctype="-" data-index="'+index+'" data-vid="'+product.variant_id+'"><i class="fal fa-minus"></i></button><input class="quantity__input" type="number" name="updates[]" value="' + product.quantity + '" min="0" id="Quantity-'+index+'"><button type="button" class="quantity-change button_primary btn-plus" data-ctype="+" data-index="'+index+'" data-vid="'+product.variant_id+'"><i class="fal fa-plus"></i></button></div></div></div></div>';
              
              concatProductInfo += '<div class="right-content text-right"><a data-id="' + product.variant_id + '" onclick="removeItem(' + product.variant_id + ',' + index + '); return false; " class="product-remove" title="Remove this product"><img src="https://cdn.shopify.com/s/files/1/0013/6698/2692/files/cart-close.png?v=1656411248" alt="close-icon"></a></div>';
              
              concatProductInfo += '</div>';
          document.getElementById('drawer_cart_items').innerHTML = document.getElementById('drawer_cart_items').innerHTML + concatProductInfo;
      });
    
  } else {
      document.getElementById('drawer_cart_items').innerHTML = '<p>Cart is empty</p>';
      document.getElementById('drawer_checkout_btn').setAttribute('disabled', 'disabled');
      document.getElementById('drawer_checkout_btn').style.pointerEvents = 'none';
  }
  var total_price = cart['total_price'] / 100;
  document.getElementById('drawer_sub_total_amount').innerHTML = '<span class="price "> ' + total_price.toFixed(2) + '</span>'
}

document.addEventListener('DOMContentLoaded', function() {
  fetchCart();
  cartCount();
});

function clearCartDrawer() {
  document.getElementById('drawer_cart_items').innerHTML = '';
}

function addCompareAtPrice(cart) {

  cart.items.forEach(function(item) {
      $.ajax({
          url: '/products/' + item.handle + '.js',
          dataType: 'json',
          async: false,
          success: function(product) {
              item["compare_at_price"] = 0;
              product.variants.forEach(function(variant) {
                  if (variant.compare_at_price != null && variant.id == item.variant_id) {
                      item["compare_at_price"] = variant.compare_at_price;
                  }
              });
          }
      });
  });

  return cart;
}

function removeItem(variantId, index, callback) {
  $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
          quantity: 0,
          line: index,
          id: variantId
      },
      success: function(cart) {
          if ((typeof callback) === 'function') {
              callback(cart);
          } else {
      
              renderCart(cart);
              fetchCart();
              cartCount();
          }
      }
  });
}
 
$(".cart-btn-close").click(function(){
$('.body-modal').removeClass('modal-overlay');
$('body').removeClass('modal-overlay-active');
$(".cart-dropdown").removeClass("drawer_active");
$('#cart-icon-bubble').removeClass("ctm-cart-color");
// $('body').removeClass('overflow-hidden');
});

if ($(window).width() < 990) {
  $('body').on('click','.header__icon--cart', function(){
    if($('body').hasClass('menu_open_body')){
      $('.header__icon--summary').trigger('click');
    }
      $(".cart-dropdown").toggleClass("drawer_active");
      $('#cart-icon-bubble').addClass("ctm-cart-color");
      $('body').addClass('modal-close');
      $('.modal-overlay').css('background', 'transparent');
      // $('body').addClass('overflow-hidden');
      if($('.cart-dropdown').hasClass('drawer_active'))
      {
        $('body').addClass('modal-overlay-active');
      }
      else{
        $('body').removeClass('modal-overlay-active');
      }
  });
} else {
  $(".cart-icon-hover").hover(function () {
      $(".cart-dropdown").addClass("drawer_active");
      $('#cart-icon-bubble').addClass("ctm-cart-color");
      $('body').addClass('modal-overlay-active');
      $('body').addClass('modal-close');
      $('.modal-overlay').css('background', 'transparent');
      // $('body').addClass('overflow-hidden');
  });
  $(".cart-icon-hover").mouseleave(function () {
    $(".cart-dropdown").removeClass("drawer_active");
    $('#cart-icon-bubble').removeClass("ctm-cart-color");
    $('body').removeClass('modal-overlay-active');
    $('body').removeClass('modal-close');
    // $('.modal-overlay').css('background', 'transparent');
  });
}

$('.modal-overlay').click(function() {
  $('.customer-account').addClass("hidden");
  $('body').toggleClass('modal-overlay-active');

  $(".cart-dropdown").removeClass("drawer_active");
  $('#cart-icon-bubble').removeClass("ctm-cart-color");
  // $('body').removeClass('overflow-hidden');

  $('#Details-menu-drawer-container').removeClass('menu-opening');
  $('body').removeClass('overflow-hidden-tablet');
  $('body').removeClass('menu_open_body');
  $('html').removeClass('menu_open_body');
  $('#shopify-section-header').removeClass('menu-open');
  $('#Details-menu-drawer-container').removeAttr('open');


});

// Sync aria-hidden on the cart drawer with its open/close state
(function() {
  var cartDrawer = document.querySelector('.cart-dropdown');
  if (!cartDrawer) return;
  new MutationObserver(function() {
    var isOpen = cartDrawer.classList.contains('drawer_active');
    cartDrawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
})();

// Hide third-party tracking iframes from accessibility tree (SC 4.1.2)
// Covers: LinkedIn Insight Tag (#li_sync_frame), ProgressBar app (#PBarNextFrame)
(function() {
  var TRACKING_IFRAMES = ['li_sync_frame', 'PBarNextFrame'];
  function hideTrackingFrames() {
    TRACKING_IFRAMES.forEach(function(id) {
      var f = document.getElementById(id);
      if (f && f.getAttribute('aria-hidden') !== 'true') {
        f.setAttribute('aria-hidden', 'true');
        f.setAttribute('tabindex', '-1');
        f.setAttribute('title', '');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(hideTrackingFrames, 2000); });
  } else {
    setTimeout(hideTrackingFrames, 2000);
  }
  new MutationObserver(function() {
    hideTrackingFrames();
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

// Fix Shogun contact form accessibility (SC 4.1.2) — contact-us page only
(function() {
  if (window.location.pathname.indexOf('/pages/contact-us') === -1) return;
  function fixShogunForm() {
    var labelMap = [
      { selector: 'input[type="text"]', label: 'Name' },
      { selector: 'input[type="email"]', label: 'Email' },
      { selector: 'textarea', label: 'Message' },
      { selector: 'select', label: 'How can we help?' }
    ];
    var shogunForm = document.querySelector('.shogun-form, [class*="shogun"]');
    if (!shogunForm) return;
    labelMap.forEach(function(item) {
      var els = shogunForm.querySelectorAll(item.selector);
      els.forEach(function(el) {
        if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
          el.setAttribute('aria-label', item.label);
        }
        var label = el.previousElementSibling || el.closest('.shogun-form-field') && el.closest('.shogun-form-field').querySelector('label');
        if (label && !label.getAttribute('for') && el.id) {
          label.setAttribute('for', el.id);
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(fixShogunForm, 1500); });
  } else {
    setTimeout(fixShogunForm, 1500);
  }
})();

$('body').on('click','.quantity-change', function(){
  
  var ctype = $(this).data('ctype');
  var vid = $(this).data('vid');
  var index = $(this).data('index');
  var CurrQty = $('#Quantity-'+index).val();
  if(ctype=='-') {
      var NewQty = parseInt(CurrQty) - parseInt(1);
      cust_changeItem(vid,index,NewQty);
  } else {
      var NewQty = parseInt(CurrQty) + 1;
      cust_changeItem(vid,index,NewQty);
  }
});

$('body').on('click','.bb-quantity-change', function(){
  var ctype = $(this).data('ctype');
  var CurrQty = $(this).parent('.quantity-field').children('.bb-quantity__input').val();
  if(ctype=='-') {
      var NewQty = parseInt(CurrQty) - parseInt(1);
  } else {
      var NewQty = parseInt(CurrQty) + 1;
  }
  if(NewQty > 0) {
      $(this).parent('.quantity-field').children('.bb-quantity__input').val(NewQty);
  }
});

$('body').on('click','.bb-form-submit', function(e){
  e.preventDefault();
  var bbQty = $(this).parent('.bb-form').find('.bb-quantity__input').val();
  var var_id = $(this).parent('.bb-form').find('.var_id').val();
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
          quantity: parseInt(bbQty),
          id: parseInt(var_id)
      },
      success: function(cart) {
          addToCartOk();
      }
  });
});

$('body').on('click','.fc-form-submit', function(e){
  
  e.preventDefault();
  var bbQty = 1;
  // var var_id = $(this).closest('.form').find('input[name="var_id"]:checked').val();
  var var_id = $(this).parent('.product-form__buttons').siblings('input[name="id"]').val();
 
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
          quantity: parseInt(bbQty),
          id: parseInt(var_id)
      },
      success: function(cart) {
          addToCartOk();
      }
  });
});

function cust_changeItem(variantId, index, quantity) {
  $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
          quantity: parseInt(quantity),
          line: index,
          id: variantId
      },
      success: function(cart) {
          fetchCart();
      }
  });
}

var swiper = new Swiper(".mySwiper", {
  slidesPerView: 1,
  spaceBetween: 10,
  // pagination: {
  //   el: ".swiper-pagination",
  //   clickable: true,
  // },
  centeredSlides: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
  },
});
